import { render, staticRenderFns } from "./guideOpenAppAlert.vue?vue&type=template&id=566dc8a8&scoped=true&"
import script from "./guideOpenAppAlert.vue?vue&type=script&lang=js&"
export * from "./guideOpenAppAlert.vue?vue&type=script&lang=js&"
import style0 from "./guideOpenAppAlert.vue?vue&type=style&index=0&id=566dc8a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566dc8a8",
  null
  
)

export default component.exports